<template>
  <div class="flex flex-col w-full h-full mx-auto p-6 overflow-auto">
    <div class="flex w-full pb-6">
      <div
        v-if="dataLoaded"
        class="w-1/2 h-80 bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div>
          <span class="font-semibold text-lg tracking-wider"
            >Levantamientos por tipo</span
          >
        </div>
        <doughnut-lev-chart
          :chartData="principalData"
          :options="doughnutChartOptions"
          :css-classes="'w-1/2 h-64 py-2 mx-auto'"
        ></doughnut-lev-chart>
      </div>

      <div
        v-if="dataLoaded"
        class="w-1/2 h-80 bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div>
          <span class="font-semibold text-lg tracking-wider">Levantamientos por estado de revisión</span>
        </div>
        <doughnut-lev-chart
          :chartData="statusData"
          :options="doughnutChartOptions"
          :css-classes="'w-1/2 h-64 py-2 mx-auto'"
        ></doughnut-lev-chart>
      </div>
    </div>

    <!-- <div class="flex w-full pb-6">
      <div
        v-if="dataLoaded"
        class="w-full h-104 bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div>
          <span class="font-semibold text-lg tracking-wider"
            >Por categoría secundaria</span
          >
        </div>
        <bar-chart
          :chartData="secundariaData"
          :options="barChartOptions"
          :css-classes="'w-full h-88 py-2 mx-auto'"
        >
        </bar-chart>
      </div>
    </div> -->

    <div class="flex w-full pb-6">
      <div
        class="flex flex-col w-full bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div class="w-full pb-2">
          <span class="font-semibold text-lg tracking-wider">Levantamientos por fechas</span>
        </div>
        <div class="flex w-full">
          <div class="w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
              for="fechaInicio"
              >Fecha inicial</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="fechaInicio"
              type="date"
              name="fechaInicio"
              v-model="fechaInicio"
              :max="startMaxDate"
              @change="checkStartCalendar"
            />
          </div>

          <div class="w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
              for="fechaFin"
              >Fecha final</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="fechaFin"
              type="date"
              name="fechaFin"
              v-model="fechaFin"
              :min="endMinDate"
              :max="endMaxDate"
              @change="checkEndCalendar"
            />
          </div>
        </div>
        <bar-chart
          :chartData="dataByDate"
          :options="barChartOptions"
          :css-classes="'w-full h-88 py-2 mx-auto'"
          v-if="dataByDateLoaded"
        >
        </bar-chart>

        <!--gráfica por municipios -->
        <div class="flex w-full pb-6">
          <div class="flex flex-col w-full mx-4 py-4 px-4">
            <div class="w-full pb-2">
              <span class="font-semibold text-lg tracking-wider"
                >Levantamientos por municipios</span
              >
            </div>

            <bar-chart
              :chartData="dataByMun"
              :options="barChartOptions"
              :css-classes="'w-full h-88 py-2 mx-auto'"
              v-if="dataByMunLoaded"
            >
            </bar-chart>
          </div>
        </div>
        <!-- /gráfica pr municipios -->

      </div>
    </div>

    <div class="flex w-full pb-6">
      <div
        class="flex flex-col w-full bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div class="w-full pb-2">
          <span class="font-semibold text-lg tracking-wider">Levantamientos por año</span>
        </div>
        <div class="flex w-full">
          <div class="w-1/5 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
              for="selectedYear"
              >Seleccionar año</label
            >
            <div class="relative">
              <select
                v-model="selectedYear"
                name="selectedYear"
                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                @change="fetchStatisticsByYear"
              >
                <template v-for="(year, index) in years">
                  <option :value="year" :key="index">{{ year }}</option>
                </template>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <bar-chart
          :chartData="dataByYear"
          :options="barChartOptions"
          :css-classes="'w-full h-88 py-2 mx-auto'"
          v-if="dataByYearLoaded"
        >
        </bar-chart>
      </div>
    </div>

    <div class="flex w-full">
      <div
        class="flex flex-col w-full bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div class="w-full pt-2 pb-2">
          <span class="font-semibold text-lg tracking-wider"
            >Actividad de Usuarios</span
          >
        </div>
        <form id="activeUsersForm" class="pt-3" @submit.prevent>
          <div
            class="flex w-full pb-3 uppercase text-gray-700 text-xs font-bold"
          >
            <div class="w-6/12 px-3 mb-0 md:mb-0">
              <span>Visualizar</span>
            </div>
            <div v-show="showSelectInterval" class="w-2/12 px-3 mb-0 md:mb-0">
              <span>Período</span>
            </div>
            <div v-show="showSelectInterval" class="w-2/12 px-3 mb-0 md:mb-0">
              <span>Cantidad</span>
            </div>
            <div
              v-show="showSelectInterval"
              class="w-2/12 px-3 mb-0 md:mb-0"
            ></div>
          </div>
          <div class="flex w-full pb-3">
            <div
              class="w-6/12 px-3 mb-0 md:mb-0"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div class="">
                <div class="">
                  <div class="space-x-16" style="display: inline-flex">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input rounded-full h-4 w-4 border border-gray-300 bg-white focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                        type="radio"
                        name="activeUser"
                        id="all"
                        value="2"
                        @click="searchActiveUsers(0)"
                      />
                      <label
                        class="form-check-label inline-block text-gray-800 select-none"
                        for="all"
                      >
                        Todos los usuarios
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input rounded-full h-4 w-4 border border-gray-300 bg-white focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                        type="radio"
                        name="activeUser"
                        id="active"
                        value="1"
                        :checked="selectedFlagUsers"
                        @click="showSelectInterval = true"
                      />
                      <label
                        class="form-check-label inline-block text-gray-800 select-none"
                        for="active"
                      >
                        Usuarios activos
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input rounded-full h-4 w-4 border border-gray-300 bg-white focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                        type="radio"
                        name="activeUser"
                        id="inactive"
                        value="0"
                        @click="showSelectInterval = true"
                      />
                      <label
                        class="form-check-label inline-block text-gray-800 select-none"
                        for="inactive"
                      >
                        Usuarios Inactivos
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="showSelectInterval" class="w-2/12 px-3 mb-6 md:mb-0">
              <div class="w-full relative">
                <select
                  @change="changeSelect2"
                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  name="perInterval"
                  id="perInterval"
                  v-model="selectedPeriod"
                >
                  <option :value="null" disabled>Seleccione un período</option>
                  <option value="week">Semanas</option>
                  <option value="month">Meses</option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
                <p
                  v-if="errors.perInterval"
                  class="text-red-500 text-xs italic text-left"
                >
                  Seleccione un período
                </p>
              </div>
            </div>
            <div v-show="showSelectInterval" class="w-2/12 px-3 mb-6 md:mb-0">
              <div class="w-full relative">
                <select
                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  v-html="quantitiesList"
                  id="qtyInterval"
                  @click="validSelAndSearch()"
                ></select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- <div v-show="showSelectInterval" class="w-2/12 px-4 mb-6 md:mb-0">
              <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" v-on:click="searchActiveUsers(1)">Buscar</button>
            </div> -->
          </div>
        </form>
        <div v-if="this.respData != ''" class="w-full pt-8 pb-4">
          <label
            class="uppercase tracking-wider text-gray-700 text-xs font-bold text-left pb-3"
            >Levantamientos realizados
            <span id="txtInfo">{{ txtIntervalSelected }}</span></label
          >
          <div class="w-full pt-4">
            <table id="tbActiveUsers" class="w-full select-none">
              <thead class="bg-gray-400">
                <tr class="table w-full table-fixed border-b">
                  <th
                    class="pt-3 pr-4 pb-4 pl-4 cursor-pointer"
                    @click="sortingByCol(0)"
                  >
                    Nombre
                    <button class="border-2 rounded border-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="h-4 w-4 fill-current"
                      >
                        <path
                          d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                        ></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                      </svg>
                    </button>
                  </th>
                  <th
                    class="pt-3 pr-4 pb-4 pl-4 cursor-pointer"
                    @click="sortingByCol(1)"
                  >
                    Apellido
                    <button class="border-2 rounded border-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="h-4 w-4 fill-current"
                      >
                        <path
                          d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                        ></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                      </svg>
                    </button>
                  </th>
                  <th
                    class="pt-3 pr-4 pb-4 pl-4 cursor-pointer"
                    @click="sortingByCol(2)"
                  >
                    Email
                    <button class="border-2 rounded border-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="h-4 w-4 fill-current"
                      >
                        <path
                          d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                        ></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                      </svg>
                    </button>
                  </th>
                  <th
                    class="pt-3 pr-4 pb-4 pl-4 cursor-pointer"
                    @click="sortingByCol(3)"
                  >
                    Cantidad
                    <button class="border-2 rounded border-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="h-4 w-4 fill-current"
                      >
                        <path
                          d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                        ></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                      </svg>
                    </button>
                  </th>
                  <th
                    class="pt-3 pr-4 pb-4 pl-4 cursor-pointer"
                    @click="sortingByCol(4)"
                  >
                    Fecha último registro
                    <button class="border-2 rounded border-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="h-4 w-4 fill-current"
                      >
                        <path
                          d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                        ></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                      </svg>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody
                v-html="rowsActiveUsers"
                class="block h-72 overflow-auto"
              ></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import BarChart from "./BarChart.vue";
import DoughnutLevChart from "./DoughnutLevChart.vue";
import moment from "moment";
import EventBus from "../event-bus";

export default {
  data() {
    return {
      doughnutChartOptions: {
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
      barChartOptions: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
      dataLoaded: false,
      principalData: {},
      statusData: {},
      secundariaData: {},
      fechaInicio: null,
      fechaFin: null,
      dataByDate: {},
      dataByDateLoaded: false,
      startMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      endMinDate: "",
      endMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      selectedPeriod: null,
      selectedFlagUsers: "1",
      quantitiesList: "",
      respData: "",
      rowsActiveUsers: "",
      dataByMun: {},
      dataByMunLoaded: false,          
      // periodsToInterval: [
      //   { id: 0, name: 'Semanas'},
      //   { id: 1, name: 'Meses'}
      // ]
      errors: {
        perInterval: false,
        qtyInterval: false,
      },
      sortingDirectionName: "asc",
      sortingDirectionLastName: "asc",
      sortingDirectionEmail: "asc",
      sortingDirectionQuantity: "asc",
      showSelectInterval: true,
      txtIntervalSelected: "",
      firstYear: null,
      selectedYear: null,
      dataByYear: {},
      dataByYearLoaded: false,
      years: [],
    };
  },
  components: {
    DoughnutLevChart,
    BarChart,
  },
  async mounted() {

    EventBus.$emit("updateNotification", {});
    this.dataLoaded = false;
    this.fetchStatistics();
    this.selectedFlagUsers = "1";


    let endDate = new Date();
    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);
    this.fechaInicio = moment(startDate).format("YYYY-MM-DD");
    this.fechaFin = moment(endDate).format("YYYY-MM-DD");

    this.selectedYear = new Date().getFullYear();
    this.fetchLevantamientoFirstDate();
    this.fetchStatisticsByMunicipio();
    this.fetchStatisticsByYear();
    this.fetchStatisticsByDate();
  },
  methods: {
    fetchStatistics() {
      this.$root.$emit("showLoading");
      this.axios
        .post("apidev/levantamientos/getLevantamientosStatistics", this.config)
        .then((response) => {
          let cat_principal = response.data.cat_principal;
          let principalLabels = [];
          let principalData = [];
          let principalColors = [];

          cat_principal.forEach((category) => {
            principalLabels.push(category.nombre);
            principalData.push(category.total);
            principalColors.push(category.color);
          });

          let dataPrincipalCollection = {
            labels: principalLabels,
            datasets: [
              {
                backgroundColor: principalColors,
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#249EBF",
                data: principalData,
              },
            ],
          };

          this.principalData = dataPrincipalCollection;

          let statusArray = response.data.status;
          let statusLabels = [];
          let statusData = [];
          let statusColors = [];

          statusArray.forEach((status) => {
            statusLabels.push(status.status);
            statusData.push(status.total);

            switch (status.status) {
              case "NO REVISADO":
                statusColors.push("#00aedb");
                break;
              case "APROBADO":
                statusColors.push("#00b159");
                break;
              case "EN REVISIÓN":
                statusColors.push("#ffc425");
                break;
              case "RECHAZADO":
                statusColors.push("#d11141");
                break;
              default:
                break;
            }
          });

          let dataStatusCollection = {
            labels: statusLabels,
            datasets: [
              {
                backgroundColor: statusColors,
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#249EBF",
                data: statusData,
              },
            ],
          };

          this.statusData = dataStatusCollection;

          let cat_secundaria = response.data.cat_secundaria;

          let datasetData = [];
          let backgroundColors = [];
          this.secundariaData.labels = [];

          cat_secundaria.forEach((category) => {
            this.secundariaData.labels.push(category.nombre);
            datasetData.push(category.total);

            cat_principal.forEach((principal) => {
              if (principal.id_cat_principal === category.id_cat_principal) {
                backgroundColors.push(principal.color);
              }
            });
          });

          this.secundariaData.datasets = [
            {
              label: "Levantamientos",
              backgroundColor: backgroundColors,
              data: datasetData,
            },
          ];

          this.dataLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    checkStartCalendar() {
      this.endMinDate = this.fechaInicio;
      if (this.fechaFin != null) {
        this.fetchStatisticsByDate();
        this.fetchStatisticsByMunicipio();
      }
    },
    checkEndCalendar() {
      this.startMaxDate = this.fechaFin;
      if (this.fechaInicio !== null) {
        this.fetchStatisticsByDate();
        this.fetchStatisticsByMunicipio();
      }
    },
    fetchStatisticsByMunicipio() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsByMunicipio",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin
          },
          this.config
        )
        .then((response) => {
          this.totalByMonth = 0
          let statisticsByMun = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByMun.forEach((statistic) => {
            labelsSet.push(statistic.municipio);
            datasetData.push(statistic.total);
            this.totalByMonth += parseInt(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByMun = dataCollection;

          this.dataByMunLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },    
    fetchStatisticsByDate() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsByDate",
          { fechaInicio: this.fechaInicio, fechaFin: this.fechaFin },
          this.config
        )
        .then((response) => {
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach((statistic) => {
            labelsSet.push(moment(statistic.date).format("DD/MM/YYYY"));
            datasetData.push(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByDate = dataCollection;

          this.dataByDateLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    changeSelect2() {
      switch (this.selectedPeriod) {
        case "week":
          this.quantitiesList =
            '<option value="1">1</option><option value="2">2</option><option value="3">3</option>';
          break;
        case "month":
          this.quantitiesList =
            "<option value='1'>1</option><option value='2'>2</option><option value='3'>3</option><option value='4'>4</option><option value='5'>5</option><option value='6'>6</option><option value='7'>7</option><option value='8'>8</option><option value='9'>9</option><option value='10'>10</option><option value='11'>11</option><option value='12'>12</option>";
          break;
      }
    },
    validSelAndSearch() {
      var selectQuantity = document.getElementById("qtyInterval").value;
      if (selectQuantity != null || selectQuantity != "") {
        this.searchActiveUsers(1);
      }
    },
    searchActiveUsers(val) {
      if (val == "0") {
        this.showSelectInterval = false;
      }

      const activeInactive = document.querySelector(
        'input[name="activeUser"]:checked'
      ).value; // si es 1: usuarios activos, si es cero: usuarios inactivos

      if (activeInactive == 2) {
        // seleccionó visualizar todos los usuarios
        this.$root.$emit("showLoading");

        this.txtIntervalSelected = " por todos los usuarios registrados";
        // console.log(this.txtIntervalSelected)

        this.axios
          .post(
            "apidev/levantamientos/getLevantamientosStatisticsByActiveUsers",
            { typeActiveUsers: activeInactive },
            this.config
          )
          .then((response) => {
            this.respData = response.data.statistics;
            console.log(this.respData);
            this.rowsActiveUsers = "";

            console.log("this.respData");
            console.log(this.respData);
            if (this.respData.length > 0) {
              let NA = "";

              for (let i = 0; i < this.respData.length; i++) {
                if (this.respData[i].ult_fecha_guardado == null) {
                  NA = "No aplica";
                  if (i % 2 != 0) {
                    this.rowsActiveUsers +=
                      '<tr class="table w-full table-fixed bg-gray-200 hover:bg-purple-200"><td class="p-4">' +
                      this.respData[i].nombre +
                      '</td><td class="p-4">' +
                      this.respData[i].apellido +
                      '</td><td class="p-4">' +
                      this.respData[i].email +
                      '</td><td class="p-4">' +
                      this.respData[i].qty_levantamientos +
                      '</td><td class="p-4">' +
                      NA +
                      "</td></tr>";
                    // console.log(this.rowsActiveUsers)
                  } else {
                    this.rowsActiveUsers +=
                      '<tr class="table w-full table-fixed bg-white hover:bg-purple-200"><td class="p-4">' +
                      this.respData[i].nombre +
                      '</td><td class="p-4">' +
                      this.respData[i].apellido +
                      '</td><td class="p-4">' +
                      this.respData[i].email +
                      '</td><td class="p-4">' +
                      this.respData[i].qty_levantamientos +
                      '</td><td class="p-4">' +
                      NA +
                      "</td></tr>";
                  }
                } else {
                  if (i % 2 != 0) {
                    this.rowsActiveUsers +=
                      '<tr class="table w-full table-fixed bg-gray-200 hover:bg-purple-200"><td class="p-4">' +
                      this.respData[i].nombre +
                      '</td><td class="p-4">' +
                      this.respData[i].apellido +
                      '</td><td class="p-4">' +
                      this.respData[i].email +
                      '</td><td class="p-4">' +
                      this.respData[i].qty_levantamientos +
                      '</td><td class="p-4">' +
                      moment(this.respData[i].ult_fecha_guardado).format(
                        "DD/MM/YYYY HH:mm:ss"
                      ) +
                      "</td></tr>";
                    // console.log(this.rowsActiveUsers)
                  } else {
                    this.rowsActiveUsers +=
                      '<tr class="table w-full table-fixed bg-white hover:bg-purple-200"><td class="p-4">' +
                      this.respData[i].nombre +
                      '</td><td class="p-4">' +
                      this.respData[i].apellido +
                      '</td><td class="p-4">' +
                      this.respData[i].email +
                      '</td><td class="p-4">' +
                      this.respData[i].qty_levantamientos +
                      '</td><td class="p-4">' +
                      moment(this.respData[i].ult_fecha_guardado).format(
                        "DD/MM/YYYY HH:mm:ss"
                      ) +
                      "</td></tr>";
                  }
                }
              }
            }

            this.dataLoaded = true;
            this.$root.$emit("hideLoading");
          })
          .catch((error) => {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.$root.$emit("hideLoading");
          });
      } else {
        const form = document.getElementById("activeUsersForm");
        const formData = new FormData(form);
        const validForm = this.checkDataForm(formData);

        if (validForm) {
          let period = document.getElementById("perInterval").value;
          let quantity = document.getElementById("qtyInterval").value;
          let translatedPeriod = "";

          if (quantity == 1) {
            if (period == "week") translatedPeriod = "semana";
            if (period == "month") translatedPeriod = "mes";
          } else {
            if (period == "week") translatedPeriod = "semanas";
            if (period == "month") translatedPeriod = "meses";
          }

          this.txtIntervalSelected =
            "EN " + quantity + " " + String(translatedPeriod).toUpperCase();
          // console.log(this.txtIntervalSelected)

          this.$root.$emit("showLoading");
          this.axios
            .post(
              "apidev/levantamientos/getLevantamientosStatisticsByActiveUsers",
              {
                typeActiveUsers: activeInactive,
                quantityInterval: quantity,
                periodInterval: period,
              },
              this.config
            )
            .then((response) => {
              this.respData = response.data.statistics;
              // console.log(this.respData);
              this.rowsActiveUsers = "";

              if (this.respData.length > 0) {
                let NA = "";

                for (let i = 0; i < this.respData.length; i++) {
                  if (this.respData[i].ult_fecha_guardado == null) {
                    NA = "No aplica";
                    if (i % 2 != 0) {
                      this.rowsActiveUsers +=
                        '<tr class="table w-full table-fixed bg-gray-200 hover:bg-purple-200"><td class="p-4">' +
                        this.respData[i].nombre +
                        '</td><td class="p-4">' +
                        this.respData[i].apellido +
                        '</td><td class="p-4">' +
                        this.respData[i].email +
                        '</td><td class="p-4">' +
                        this.respData[i].qty_levantamientos +
                        '</td><td class="p-4">' +
                        NA +
                        "</td></tr>";
                      // console.log(this.rowsActiveUsers)
                    } else {
                      this.rowsActiveUsers +=
                        '<tr class="table w-full table-fixed bg-white hover:bg-purple-200"><td class="p-4">' +
                        this.respData[i].nombre +
                        '</td><td class="p-4">' +
                        this.respData[i].apellido +
                        '</td><td class="p-4">' +
                        this.respData[i].email +
                        '</td><td class="p-4">' +
                        this.respData[i].qty_levantamientos +
                        '</td><td class="p-4">' +
                        NA +
                        "</td></tr>";
                    }
                  } else {
                    if (i % 2 != 0) {
                      this.rowsActiveUsers +=
                        '<tr class="table w-full table-fixed bg-gray-200 hover:bg-purple-200"><td class="p-4">' +
                        this.respData[i].nombre +
                        '</td><td class="p-4">' +
                        this.respData[i].apellido +
                        '</td><td class="p-4">' +
                        this.respData[i].email +
                        '</td><td class="p-4">' +
                        this.respData[i].qty_levantamientos +
                        '</td><td class="p-4">' +
                        moment(this.respData[i].ult_fecha_guardado).format(
                          "DD/MM/YYYY HH:mm:ss"
                        ) +
                        "</td></tr>";
                      // console.log(this.rowsActiveUsers)
                    } else {
                      this.rowsActiveUsers +=
                        '<tr class="table w-full table-fixed bg-white hover:bg-purple-200"><td class="p-4">' +
                        this.respData[i].nombre +
                        '</td><td class="p-4">' +
                        this.respData[i].apellido +
                        '</td><td class="p-4">' +
                        this.respData[i].email +
                        '</td><td class="p-4">' +
                        this.respData[i].qty_levantamientos +
                        '</td><td class="p-4">' +
                        moment(this.respData[i].ult_fecha_guardado).format(
                          "DD/MM/YYYY HH:mm:ss"
                        ) +
                        "</td></tr>";
                    }
                  }
                }

                this.dataLoaded = true;
                this.$root.$emit("hideLoading");
              }
            })
            .catch((error) => {
              if (
                error.response.status == 400 ||
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              this.$root.$emit("hideLoading");
            });
        } else {
          console.log("Formulario no válido");
        }
      }
    },
    checkDataForm: function (dataForm) {
      // console.log(dataForm.get("perInterval"));

      if (dataForm.get("perInterval") === null) {
        this.errors.perInterval = true;
      } else {
        this.errors.perInterval = false;
      }

      if (this.errors.perInterval) {
        return false;
      }

      return true;
    },
    sortingByCol(n) {
      var table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        dir,
        switchcount = 0,
        tr;
      table = document.getElementById("tbActiveUsers");
      switching = true;
      //Set the sorting direction to ascending:
      dir = "asc";
      /*Make a loop that will continue until
      no switching has been done:*/
      while (switching) {
        //start by saying: no switching is done:
        switching = false;
        rows = table.rows;
        /*Loop through all table rows (except the
        first, which contains table headers):*/
        for (i = 1; i < rows.length - 1; i++) {
          //start by saying there should be no switching:
          let dateX, dateY;
          shouldSwitch = false;
          /*Get the two elements you want to compare,
          one from current row and one from the next:*/
          x = rows[i].getElementsByTagName("TD")[n];
          y = rows[i + 1].getElementsByTagName("TD")[n];
          /*check if the two rows should switch place,
          based on the direction, asc or desc:*/

          if (n == 3) {
            if (dir == "asc") {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                //if so, mark as a switch and break the loop:
                shouldSwitch = true;
                break;
              }
            } else if (dir == "desc") {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else {
            if (n == 4) {
              if (x.innerHTML != "No aplica") {
                if (y.innerHTML != "No aplica") {
                  dateX = new Date(
                    String(x.innerHTML).replace(
                      /(\d{2})\/(\d{2})\/(\d{4})/,
                      "$2/$1/$3"
                    )
                  );
                  dateY = new Date(
                    String(y.innerHTML).replace(
                      /(\d{2})\/(\d{2})\/(\d{4})/,
                      "$2/$1/$3"
                    )
                  );
                  if (dir == "asc") {
                    if (dateX > dateY) {
                      shouldSwitch = true;
                      break;
                    }
                  } else if (dir == "desc") {
                    if (dateX <= dateY) {
                      shouldSwitch = true;
                      break;
                    }
                  }
                } else {
                  console.log("ambos son 'no aplica'");
                }
              } else {
                console.log("x es 'no aplica'");
              }
            } else {
              if (dir == "asc") {
                if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                  shouldSwitch = true;
                  break;
                }
              } else if (dir == "desc") {
                if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                  shouldSwitch = true;
                  break;
                }
              }
            }
          }
        }
        if (shouldSwitch) {
          /*If a switch has been marked, make the switch
          and mark that a switch has been done:*/
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          //Each time a switch is done, increase this count by 1:
          switchcount++;
        } else {
          /*If no switching has been done AND the direction is "asc",
          set the direction to "desc" and run the while loop again.*/
          if (switchcount == 0 && dir == "asc") {
            dir = "desc";
            switching = true;
          }
        }
      }

      // obtiene todas las filas del cuerpo de la tabla
      tr = document.getElementsByTagName("tr");

      // elimina las clases 'bg-white' y 'bg-gray-200'
      for (let i = 0; i < tr.length; i++) {
        // i = 0 es la fila del thead
        if (i != 0) {
          if (tr[i].classList.contains("bg-white")) {
            tr[i].classList.remove("bg-white");
          }
          if (tr[i].classList.contains("bg-gray-200")) {
            tr[i].classList.remove("bg-gray-200");
          }
        }
      }

      // inserta las clases 'bg-white' y 'bg-gray-200', si la fila es impar o par
      for (let i = 0; i < tr.length; i++) {
        // i = 0 es la fila del thead
        if (i != 0) {
          if (i % 2 != 0) {
            tr[i].classList.add(
              "table",
              "w-full",
              "table-fixed",
              "bg-white",
              "hover:bg-purple-200"
            );
          } else {
            tr[i].classList.add(
              "table",
              "w-full",
              "table-fixed",
              "bg-gray-200",
              "hover:bg-purple-200"
            );
          }
        }
      }
    },
    fetchStatisticsByYear() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsByYear",
          { year: this.selectedYear },
          this.config
        )
        .then((response) => {
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach((statistic) => {
            let monthLabel = moment(statistic.date).format("MMMM");
            monthLabel =
              monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1);
            labelsSet.push(monthLabel);
            datasetData.push(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByYear = dataCollection;

          this.dataByYearLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchLevantamientoFirstDate() {
      this.$root.$emit("showLoading");
      this.axios
        .get("apidev/levantamientos/getLevantamientoFirstDate", this.config)
        .then((response) => {
          let firstDate = new Date(response.data.firstdate[0].date);
          this.firstYear = firstDate.getFullYear();

          let yearDifference = this.selectedYear - this.firstYear;

          for (let index = 0; index <= yearDifference; index++) {
            this.years.push(this.selectedYear - index);
          }

          this.years.sort();

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
  },
};
</script>

<style scoped>
.overflow-auto::-webkit-scrollbar {
  width: 8px;
}

/* track */
.overflow-auto::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #f7fafc;
  border-radius: 15px;
}

.overflow-auto::-webkit-scrollbar-thumb {
  background: #b3b3b3;
  border-radius: 15px;
}

.overflow-auto::-webkit-scrollbar-thumb:hover {
  background: #797979;
}
</style>
